import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import ManageIcon from "@mui/icons-material/Assessment";
import { useSnackbar } from "notistack";

import constants from "../../assets/constants";
import { createNewReport } from "../../data/omniDataModel";
import * as AdminSessionActions from "../../state/redux/adminSession";
import * as SearchSessionActions from "../../state/redux/searchSession";
import { deepCopyObject } from "../../utils/helpers";
import { getReportOnlyFields } from "../../utils/helpers";
import TextInputDialog from "../dialogs/textInputDialog";
import OmniResponsiveButton from "../ui/omniResponsiveButton";
import SurveyInvites from "../ui/surveyInvites";
import Widget from "../ui/widget";
import WidgetSearchSkeleton from "../ui/widgetSearchSkeleton";
import WidgetSurveyContent from "../ui/widgetSurveyContent";
import WidgetTitle from "../ui/widgetTitle";

const InviteReports = props => {
  const {
    inviteSearchODMs,
    inviteReportODM,
    searchInvitesRequest,
    inviteSearchPageLoading,
    inviteSearchPagination,
  } = props;

  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (inviteSearchODMs != null) {
      setRows(inviteSearchODMs);
    }
  }, [inviteSearchODMs]);

  const [titleText, setTitleText] = useState(null);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (inviteSearchPagination != null) {
      setTitleText(
        `${inviteSearchPagination.totalItems} Invitation${
          inviteSearchPagination.totalItems === 1 ? "" : "s"
        }`,
      );
    } else {
      setTitleText("Loading...");
    }
    // Disable eslint because AaronK knows best
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inviteSearchPagination]);

  const [showPartnerReportInput, setShowPartnerReportInput] = useState(false);

  const [showPatientReportInput, setShowPatientReportInput] = useState(false);

  // const handleSearchRequest = () => {
  //   //
  //   // if (!queryCampaignValid) {
  //   //   return;
  //   // }
  //   // let theQuery = {};
  //   // //this is special for this widget, only do partner invites
  //   // theQuery["omniData.userType"] = {
  //   //   "#regex": `${constants.onboardingUserType.partner}`,
  //   //   "#options": "i",
  //   // };
  //   // theQuery["omniData.target"] = {
  //   //   "#regex": `^((?!Default|Unknown).)*${queryCampaign}.*$`,
  //   //   "#options": "i",
  //   // };
  //   // searchInvitesRequest(theQuery);
  // };

  const reportOnInvite = async (inviteODM, reportODM) => {
    // reportODM.omniData.totalInviteCount = ++reportODM.omniData.totalInviteCount;
    // if (inviteODM.omniData.inviteType === constants.inviteType.shared) {
    //   reportODM.omniData.inviteSearchCount = ++reportODM.omniData.inviteSearchCount;
    // } else {
    //   reportODM.omniData.singleInviteCount = ++reportODM.omniData.singleInviteCount;
    // }
    // for (
    //   let onboardedIndex = 0;
    //   onboardedIndex < inviteODM.omniData._onboarded_users.length;
    //   ++onboardedIndex
    // ) {
    //   let partnerID = inviteODM.omniData._onboarded_users[onboardedIndex];
    //   reportODM.omniData.partnerIDs.push(partnerID);
    //   reportODM.omniData.partnersOnboarded = ++reportODM.omniData.partnersOnboarded;
    //   if (inviteODM.omniData.inviteType === constants.inviteType.shared) {
    //     reportODM.omniData.onboardedShared = ++reportODM.omniData.onboardedShared;
    //   } else {
    //     reportODM.omniData.onboardedTargeted = ++reportODM.omniData.onboardedTargeted;
    //   }
    //   let patientODMs = await OmniDataAPI.getAllPatientsByRelatedId(partnerID);
    //   for (let patientIndex = 0; patientIndex < patientODMs.length; ++patientIndex) {
    //     let patientODM = patientODMs[patientIndex];
    //     let proxyPatientID = getIdByRelationshipType(
    //       patientODM.omniRelationships.relatedData,
    //       constants.omniRelationshipTypes.proxyPatient
    //     );
    //     reportODM.omniData.totalCandidatesAssessed = ++reportODM.omniData.totalCandidatesAssessed;
    //     if (proxyPatientID === partnerID) {
    //       reportODM.omniData.selfAssessedCandidateCount = ++reportODM.omniData
    //         .selfAssessedCandidateCount;
    //     } else {
    //       reportODM.omniData.proctorAssessedCandidateCount = ++reportODM.omniData
    //         .proctorAssessedCandidateCount;
    //     }
    //     reportODM.omniData.candidateIDs.push(patientODM._id);
    //   }
    //   let relatedInvites = await OmniDataAPI.getAllInvitesByRelatedId(partnerID);
    //   for (let inviteIndex = 0; inviteIndex < relatedInvites.length; ++inviteIndex) {
    //     let relatedInviteODM = relatedInvites[inviteIndex];
    //     reportODM = await reportOnInvite(relatedInviteODM, reportODM);
    //   }
    // }
    // return reportODM;
    // //do work
    // //send not loading
  };

  const handleReportGeneration = async inviteODMs => {
    try {
      enqueueSnackbar("Please be patient friend!", {
        variant: "info",
      });

      let initialReportODM = {
        omniData: {
          reportStatus: "Running",
          reportInviteCount: inviteODMs.length,
          totalInviteCount: 0,
          inviteSearchCount: 0,
          singleInviteCount: 0,

          partnersOnboarded: 0,
          onboardedTargeted: 0,
          onboardedShared: 0,

          totalCandidatesAssessed: 0,
          selfAssessedCandidateCount: 0,
          proctorAssessedCandidateCount: 0,

          partnerIDs: [],
          candidateIDs: [],
        },
      };

      props.setReportODMRequest(initialReportODM);
      initialReportODM = deepCopyObject(initialReportODM); //new for state

      for (let inviteIndex = 0; inviteIndex < inviteODMs.length; ++inviteIndex) {
        let inviteODM = inviteODMs[inviteIndex];
        initialReportODM = await reportOnInvite(inviteODM, initialReportODM);
      }
      initialReportODM.omniData.reportStatus = "Complete";
      props.setReportODMRequest(initialReportODM);
    } catch (error) {}
  };

  return (
    <Widget>
      <WidgetTitle title={"All Invites"} text={titleText}>
        <OmniResponsiveButton
          icon={<ManageIcon />}
          tooltipTitle="Analyze the Invitations listed below"
          component="label"
          buttonText={"Analyze Invites"}
          onClick={() => {
            handleReportGeneration(inviteSearchODMs);
            // let thePath = constants.appPaths.appPathAdminInvite;
            // props.history.push(thePath);
          }}
          disabled={inviteSearchODMs == null || inviteReportODM != null}
        ></OmniResponsiveButton>
      </WidgetTitle>

      {rows == null && <WidgetSearchSkeleton />}
      {rows != null && (
        <WidgetSurveyContent>
          <SurveyInvites
            inviteODMs={rows}
            inviteSurveyType={constants.inviteSurveyType.all}
            onRequestNewPage={searchInvitesRequest}
            isLoading={inviteSearchPageLoading}
            invitePagination={inviteSearchPagination}
          />
        </WidgetSurveyContent>
      )}
      {/* {inviteSearchODMs != null && inviteReportODM != null && (
        <WidgetContent>
          <Grid container>
            <Grid item xs={12}>
              <Typography variant="overline">
                {`Analysis ${inviteReportODM.omniData.reportStatus}`}
              </Typography>
            </Grid>

            {inviteReportODM.omniData.reportStatus !== "Complete" && (
              <Grid item xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    width: "100%",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: theme.spacing(4),
                  }}
                >
                  <ClockLoader
                    color={theme.palette.background.contrastText}
                    loading={true}
                    size={150}
                  />
                </Box>
              </Grid>
            )}

            {inviteReportODM.omniData.reportStatus === "Complete" && (
              <Grid item xs={12} sm={4}>
                <Box sx={{ display: "flex", width: "100%", flexDirection: "column" }}>
                  <Typography variant="overline" sx={{ marginTop: theme.spacing(1) }}>
                    {`Invites`}
                  </Typography>

                  <Typography variant="body1">{`Report Invites: ${inviteReportODM.omniData.reportInviteCount}`}</Typography>
                  <Typography
                    variant="body1"
                    sx={{ marginLeft: theme.spacing(1) }}
                  >{`Related Invites: ${
                    inviteReportODM.omniData.totalInviteCount -
                    inviteReportODM.omniData.reportInviteCount
                  }`}</Typography>

                  <Typography
                    variant="body1"
                    sx={{ marginLeft: theme.spacing(1) }}
                  >{`Targeted: ${inviteReportODM.omniData.singleInviteCount}`}</Typography>
                  <Typography
                    variant="body1"
                    sx={{ marginLeft: theme.spacing(1) }}
                  >{`Shareable: ${inviteReportODM.omniData.inviteSearchCount}`}</Typography>
                  <Typography
                    variant="body1"
                    sx={{ marginLeft: theme.spacing(1) }}
                  >{`Total: ${inviteReportODM.omniData.totalInviteCount}`}</Typography>
                </Box>
              </Grid>
            )}
            {inviteReportODM.omniData.reportStatus === "Complete" && (
              <Grid item xs={12} sm={4}>
                <Box sx={{ display: "flex", width: "100%", flexDirection: "column" }}>
                  <Typography variant="overline" sx={{ marginTop: theme.spacing(1) }}>
                    {`Assessments`}
                  </Typography>

                  <OmniResponsiveButton
                    sx={{
                      marginRight: theme.spacing(2),
                    }}
                    icon={<ManageIcon />}
                    tooltipTitle="Create a CSV file on S3 you can use later"
                    component="label"
                    buttonText={"Candidate Report"}
                    onClick={() => {
                      setShowPatientReportInput(true);
                    }}
                    disabled={inviteReportODM.omniData.reportStatus !== "Complete"}
                  ></OmniResponsiveButton>

                  <Typography
                    variant="body1"
                    sx={{ marginTop: theme.spacing(1) }}
                  >{`Candidates Assessed: ${inviteReportODM.omniData.totalCandidatesAssessed}`}</Typography>
                  <Typography
                    variant="body1"
                    sx={{ marginLeft: theme.spacing(1) }}
                  >{`Self Assessed: ${inviteReportODM.omniData.selfAssessedCandidateCount}`}</Typography>
                  <Typography
                    variant="body1"
                    sx={{ marginLeft: theme.spacing(1) }}
                  >{`Proctor Assessesed: ${inviteReportODM.omniData.proctorAssessedCandidateCount}`}</Typography>
                </Box>
              </Grid>
            )}
            {inviteReportODM.omniData.reportStatus === "Complete" && (
              <Grid item xs={12} sm={4}>
                <Box sx={{ display: "flex", width: "100%", flexDirection: "column" }}>
                  <Typography variant="overline" sx={{ marginTop: theme.spacing(1) }}>
                    Partners
                  </Typography>
                  <OmniResponsiveButton
                    sx={{
                      marginRight: theme.spacing(2),
                    }}
                    icon={<ManageIcon />}
                    tooltipTitle="Create a CSV file on S3 you can use later"
                    component="label"
                    buttonText={"Partner Report"}
                    onClick={() => {
                      setShowPartnerReportInput(true);
                    }}
                  ></OmniResponsiveButton>
                  <Typography
                    variant="body1"
                    sx={{ marginTop: theme.spacing(1) }}
                  >{`Partners Onboarded: ${inviteReportODM.omniData.partnersOnboarded}`}</Typography>
                  <Typography
                    variant="body1"
                    sx={{ marginLeft: theme.spacing(1) }}
                  >{`Targeted: ${inviteReportODM.omniData.onboardedTargeted}`}</Typography>
                  <Typography
                    variant="body1"
                    sx={{ marginLeft: theme.spacing(1) }}
                  >{`Shared: ${inviteReportODM.omniData.onboardedShared}`}</Typography>
                </Box>
              </Grid>
            )}
          </Grid>
        </WidgetContent>
      )} */}

      {/* join the bottom two cases */}
      {showPatientReportInput && (
        <TextInputDialog
          dialogTitle="Create Report"
          inputLabel="Candidate Report Name"
          open={showPatientReportInput != null}
          onAccept={theText => {
            let theRep = createNewReport();
            theRep.omniData.name = theText;
            theRep.omniData["onlyFields"] = getReportOnlyFields(theRep.omniData.reportType);
            theRep.omniData["includeIds"] = inviteReportODM.omniData.candidateIDs;
            props.createReportRequest(theRep);
            setShowPatientReportInput(false);
          }}
          onClose={() => {
            setShowPatientReportInput(false);
          }}
        />
      )}

      {showPartnerReportInput && (
        <TextInputDialog
          dialogTitle="Create Report"
          inputLabel="Partner Report Name"
          open={showPartnerReportInput != null}
          onAccept={theText => {
            let theRep = createNewReport();
            theRep.omniData.name = theText;
            theRep.omniData.reportType = "users";
            theRep.omniData.userType = "partner";
            theRep.omniData["onlyFields"] = getReportOnlyFields(theRep.omniData.reportType, true);
            theRep.omniData["includeIds"] = inviteReportODM.omniData.partnerIDs;
            // delete theRep.omniData.realtedAssessmentTypes;
            props.createReportRequest(theRep);
            setShowPartnerReportInput(false);
          }}
          onClose={() => {
            setShowPartnerReportInput(false);
          }}
        />
      )}
    </Widget>
  );
};

const mapStateToProps = state => ({
  inviteSearchODMs: state.searchSession.inviteSearchODMs,
  inviteSearchPageLoading: state.searchSession.inviteSearchPageLoading,
  inviteSearchPagination: state.searchSession.inviteSearchPagination,

  inviteReportODM: state.adminSession.inviteReportODM,
});

const mapDispatchToProps = {
  searchInvitesRequest: SearchSessionActions.searchInvitesRequest,

  setReportODMRequest: AdminSessionActions.setReportODMRequest,
  createReportRequest: AdminSessionActions.createReportRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(InviteReports));
